<p>ng-form-input-single-check works!</p>
